<div class="container-xxl">
    <div class="mt-3">
        <div class="row">
            <h2 class="col-12 my-auto text-start">Modifica marcatore</h2>
        </div>
    </div>

    <form autocomplete="on" [formGroup]="formGroup" (ngSubmit)="onSubmit()" novalidate class="mt-3">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="field">
                    <label for="tipoMarcatore">Tipo marcatore</label>
                    <p-dropdown
                        [options]="this.tipoMarcatoreList"
                        (onChange)="generateNewName()"
                        placeholder="Seleziona uno tipo"
                        formControlName="tipoMarcatore"
                    ></p-dropdown>
                </div>
                <small *ngIf="isFieldInvalid('tipoMarcatore')" class="p-error block">Valore richiesto</small>
            </div>

            <div class="col-12 col-md-6">
                <div class="field">
                    <label for="corpoId">Seleziona corpo</label>
                    <p-dropdown [options]="this.corpiAbilitati" placeholder="Seleziona uno corpo" formControlName="corpoId"></p-dropdown>
                </div>
            </div>

            <div [formGroupName]="'posizione'" class="col-12 col-md-6">
                <div class="field">
                    <label for="posizione.y">Latitudine</label>
                    <input pInputText formControlName="y" type="number" />
                    <small *ngIf="isFieldInvalid('posizione.y')" class="p-error block">Valore richiesto</small>
                </div>
            </div>

            <div [formGroupName]="'posizione'" class="col-12 col-md-6">
                <div class="field">
                    <label for="posizione.x">Longitudine</label>
                    <input pInputText formControlName="x" type="number" />
                    <small *ngIf="isFieldInvalid('posizione.x')" class="p-error block">Valore richiesto</small>
                </div>
            </div>

            <div class="col-12 col-md-6">
                <div class="field">
                    <label for="nome">Nome</label>
                    <input pInputText formControlName="nome" type="text" />
                    <small *ngIf="isFieldInvalid('nome')" class="p-error block">Valore richiesto</small>
                </div>
            </div>

            <div class="col-12 col-md-6">
                <div class="field">
                    <label for="descrizione">Descrizione</label>
                    <textarea pInputText formControlName="descrizione" rows="3"></textarea>
                    <small *ngIf="isFieldInvalid('descrizione')" class="text-danger">Minimo 3 caratteri</small>
                </div>
            </div>

            <div class="col-12 col-md-6">
                <div class="field">
                    <label for="statoMarcatore">Stato marcatore</label>
                    <p-dropdown
                        [options]="this.statoMarcatoreList"
                        placeholder="Seleziona uno stato"
                        formControlName="statoMarcatore"
                    ></p-dropdown>
                </div>
                <small *ngIf="isFieldInvalid('statoMarcatore')" class="p-error block">Valore richiesto</small>
            </div>

            <div class="col-12 col-md-6">
                <div class="field">
                    <label for="ultimoControllo">Ultimo controllo</label>
                    <input pInputText formControlName="ultimoControllo" type="date" />
                    <small *ngIf="isFieldInvalid('ultimoControllo')" class="p-error block">Valore richiesto</small>
                </div>
            </div>

            <div class="col-12">
                <button pButton type="submit" label="Salva"></button>
                <button pButton type="button" (click)="showConfirmDelete()" label="Rimuovi" class="ms-3"></button>
                <button pButton label="Annulla" (click)="onCancel()" class="ms-3"></button>
            </div>
        </div>
    </form>
</div>
